import {createFileRoute, Outlet, useLocation} from '@tanstack/react-router';
import {practitionerAdminGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import PractitionerEdit from '@/practitioner/views/practitioner/PractitionerEdit';

const PractitionerLayout = () => {
  const {pathname} = useLocation();
  const isRoot = /^\/u\/company\/practitioners\/[a-z0-9-]{36}$/.test(pathname);
  return isRoot ? <PractitionerEdit /> : <Outlet />;
};

export const Route = createFileRoute('/(practitioner)/company/practitioners/$practitionerId')({
  component: PractitionerLayout,
  beforeLoad: grantUser(practitionerAdminGranted),
  loader: ({params}) => ({
    practitionerId: params.practitionerId
  })
});
